import { useState } from 'react';
import { useLocation, Outlet, useParams } from 'react-router-dom';
import { usePublishedAdaptationStories } from '@services/query.service';
import { useSelector } from 'react-redux';

import { useTranslation } from '@utils/i18n/i18n.consumers';
import { useMapBounds } from '@services/hooks.service';

import AdaptationListComponent from '../AdaptationListComponent';
import AdaptationStoryActionCard from '../../AdaptationStoryActionCard/AdaptationStoryActionCard';
import MapMarkerLayer from '../../MapMarkerLayer/MapMarkerLayer';
import { mapBoundsFilter } from '../adaptation-list-component.utils';

import './stories-list.styl';

function StoriesList() {
  const [selectedMarker, setSelectedMarker] = useState(null);

  const location = useLocation();
  const { t } = useTranslation()
  const { data: adaptationStories = [] } = usePublishedAdaptationStories();
    
  const isCreateView = location.pathname.match(/\/adaptation\/stories\/create/);

  const map = useSelector(state => state.maplibremap.map);

  const mapBounds = useMapBounds(map);
  const filteredData = mapBoundsFilter(adaptationStories, mapBounds);

  const { id } = useParams();

  return (
    <div className="stories-list">
      {id || isCreateView ? (
        <Outlet />
      ) : (
        <>
          <AdaptationListComponent selectedCategory="stories" />
          {filteredData.length === 0 && (
            <div className="all-list__no-data">
              <span>{t('No stories here yet. Zoom out or pan on the map to find more stories.')}</span>
            </div>
          )}
          <div className="all-list__cards">
            {filteredData.map(card => (
              <AdaptationStoryActionCard key={card.id} data={card} selectedData={selectedMarker} />
            ))}
          </div>
            
          <MapMarkerLayer
            markerData={adaptationStories}
            setSelectedMarker={setSelectedMarker}
            selectedMarker={selectedMarker}
          />
        </>
      )}
    </div>
  );
}

export default StoriesList;
